import { useState } from "react"
import { ChevronDown } from "lucide-react"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu,
  useSidebar,
} from "@/components/ui/sidebar"
import { cn } from "@/lib/utils"

interface CollapsibleSidebarGroupProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}

export function CollapsibleSidebarGroup({
  title,
  children,
  defaultOpen = true,
}: CollapsibleSidebarGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const { state, isMobile } = useSidebar()
  // The icon rail has no label to click open again, so a group folded in the
  // full sidebar would vanish from it entirely. The rail always shows every
  // group, divided by a hairline where the label was.
  const iconRail = state === "collapsed" && !isMobile

  return (
    <SidebarGroup>
      {iconRail && <div aria-hidden className="mx-auto mb-1 h-px w-5 bg-border" />}
      <SidebarGroupLabel
        className="cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="flex items-center justify-between w-full">
          <span>{title}</span>
          <ChevronDown
            className={cn(
              "h-3.5 w-3.5 transition-transform duration-200",
              !isOpen && "-rotate-90"
            )}
          />
        </span>
      </SidebarGroupLabel>
      {(isOpen || iconRail) && (
        <SidebarGroupContent>
          <SidebarMenu>{children}</SidebarMenu>
        </SidebarGroupContent>
      )}
    </SidebarGroup>
  )
}
